import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <footer className={styles.container}>
      <ul className={styles.linkList}>
        <li>
          <Link to="/legal-mentions" target="_blank" rel="noopener noreferrer">
            Mentions légales
          </Link>
        </li>
        <li>
          <Link to="/cgu" target="_blank" rel="noopener noreferrer">
            Conditions générales d'utilisation
          </Link>
        </li>
        <li>
          <Link to="/cgv" target="_blank" rel="noopener noreferrer">
            Conditions générales de vente
          </Link>
        </li>
        <li>
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Politique de confidentialité (cookies)
          </Link>
        </li>
        <li>
          <Link to="/signaler">Contact</Link>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
